import { NextPageContext } from 'next/dist/shared/lib/utils'
import { Store } from 'redux'
import { professionsSearchThunks } from '@ucheba/store/professions/search'
import ProfPage from './index'

ProfPage.getInitialProps = async (
  ctx: NextPageContext & { store: Store }
): Promise<any> => {
  const { store } = ctx
  const { dispatch } = store

  await dispatch(professionsSearchThunks.fetch({ ctx, data: { limit: 10 } }))

  return {
    content: {
      seo: {
        title: 'Каталог профессий — Учёба.ру',
        description:
          'Собрали всю информацию о профессиях: чем занимается, как стать, где работать и какое образование нужно получить. Выбери профессию своей мечты!',
      },
    },
  }
}

export default ProfPage
